import React from 'react';
import { IncomeProtectionContract, IncomeProtectionDetails } from '~/scenes';
import { Stack } from '../stackNavigation';

export const IncomeProtectionNavigation = (
  <Stack.Group>
    <Stack.Screen
      name="MarisaServicos_IncomeProtectionDetails"
      component={IncomeProtectionDetails}
    />

    <Stack.Screen
      name="MarisaServicos_IncomeProtectionContract"
      component={IncomeProtectionContract}
    />
  </Stack.Group>
);
